'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen bg-paper-white flex items-center justify-center">
      <div className="text-center px-gutter">
        <h1 className="text-4xl font-bold text-ink-900 mb-4" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          Error
        </h1>
        <p className="text-body text-ink-600 mb-8 max-w-md mx-auto">
          Ha ocurrido un error al cargar esta página. Por favor, inténtalo de nuevo.
        </p>
        <button
          onClick={() => reset()}
          className="btn-primary"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}
